import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-listbox',
    templateUrl: './listbox.component.html',
    styleUrls: ['./listbox.component.scss'],
    standalone: false
})
export class ListboxComponent implements OnInit {


  @Input("itemsMap") itemsMap: Map<string, any>;
  @Input("componentId") cid: string;
  @Input("listName") listName: string;
  @Input() minHeight: string = '500px';
  @Input() maxHeight: string = '500px';
  @Input() itemStateChanged = new EventEmitter<Object>();
  @Output() componentSelect = new EventEmitter<string>();

  search: string = '';
  activedescendentItem: string = null;

  leftAreaItems: any[];


  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.search.toUpperCase()
  }

  ngAfterViewInit(): void {
  }

  onSelect($event: any, item: any) {
    item.value.selected = item.value.selected == true ? false : true;
    this.componentSelect.emit(this.cid);
  }

  selectOrUnselectAll($event: any) {
    this.iterateAndSetSelectedStatus($event.currentTarget.checked);
  }

  iterateAndSetSelectedStatus(selected: boolean) {
    this.itemsMap.forEach((item: any, key: string) => {
      item.selected = selected;
    });
    this.componentSelect.emit(this.cid);
  }
}
